import { HTMLAttributes, ReactNode } from 'react';
import { css } from '@emotion/react';
import { css as linariaCss, cx } from '@linaria/atomic';

export interface TableCustomToolbarProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

/**
 * Wrapper for content passed to a design-system `<Table>` via `customToolbarRender`
 * (e.g. page filters). Pair it with `tableCustomToolbarStyles` on the table's
 * `wrapperStyle` so the table's own toolbar container gets consistent spacing.
 */
export const TableCustomToolbar = ({ children, className, ...rest }: TableCustomToolbarProps) => (
  <div className={cx(styles.wrapper, className)} {...rest}>
    {children}
  </div>
);

TableCustomToolbar.displayName = 'TableCustomToolbar';

export const tableCustomToolbarStyles = css`
  .table-toolbar {
    margin-top: var(--fabric-space-gap-lg);
    margin-bottom: var(--fabric-space-gap-lg);
    padding: 0;
  }
`;

const styles = {
  wrapper: linariaCss`
    display: flex;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0%;
  `,
};
